/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Noisy_That_Martin_FeastInputs */

const fr_noisy_that_martin_feast = /** @type {(inputs: Noisy_That_Martin_FeastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement`)
};

/**

* @param {Noisy_That_Martin_FeastInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const noisy_that_martin_feast = /** @type {((inputs?: Noisy_That_Martin_FeastInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Noisy_That_Martin_FeastInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_noisy_that_martin_feast(inputs)
});